/**
 * 
 * @param {import('./UpdateRealCargoDialog').RealCargo} item 
 * @param {any[]} cargoTypes 
 * @returns 
 */
export const checkIfUpdate = (item, cargoTypes) => {
    if (item.parent.red.name === '') {
        return false;
    }

    if (item.name === '') {
        return false;
    }

    const isChecked = cargoTypes.find(cargoType => item.parent.red.name === cargoType.name);

    return !!isChecked;
};

/**
 * 
 * @param {import('./UpdateRealCargoDialog').Gazetter} item 
 * @param {any[]} cargoTypes 
 * @returns 
 */
export const checkIfUpdateGazetter = (item, cargoTypes) => {
    if (!item.CargoCategory) {
        return false;
    }

    if (item.realCargoName === '') {
        return false;
    }

    const isChecked = cargoTypes.find(cargoType => item.CargoCategoryName === cargoType.name);

    return !!isChecked;
};




// WEBPACK FOOTER //
// ./app/components/Cargoes/Assigners/utils.js